(() => {
  if (window.productTreatmentHelp) return;
  window.productTreatmentHelp = true;
  let dialog, opener;
  function openHelp(button) {
    opener = button;
    if (!dialog) {
      dialog = document.createElement('dialog');
      dialog.className = 'product-treatment-help';
      dialog.setAttribute('aria-labelledby', 'product-treatment-help-title');
      dialog.innerHTML = `<button type="button" class="product-treatment-help__close" aria-label="Close treatment explanation">Close</button>
        <h2 id="product-treatment-help-title">Gloss or matte lacquer?</h2>
        <p>Lacquer is a clear protective coating over the metal finish. Gloss and matte describe how that coating reflects light.</p>
        <p><strong>Gloss lacquer</strong> gives the surface a brighter, more reflective sheen.</p>
        <p><strong>Matte lacquer</strong> softens the reflection for a more subdued sheen.</p>
        <p>Both are lacquered finishes. Matte does not mean unlacquered; unlacquered brass has no lacquer coating and develops a patina over time.</p>
        <p>Choose the sheen you prefer, then match the full finish and treatment name across coordinating pieces. Only the treatments offered for your selected finish appear on this page.</p>`;
      document.body.append(dialog);
      dialog.querySelector('button').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if(event.target !== dialog)return;
        const r=dialog.getBoundingClientRect();
        if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();
      });
      dialog.addEventListener('close', () => { if(opener?.isConnected)opener.focus(); });
    }
    dialog.showModal();
  }
  function arrange() {
    document.querySelectorAll('product-info [data-dependent-finish]').forEach(selector => {
      const choice = selector.querySelector('[data-dependent-finish-treatments]');
      const fixed = selector.querySelector('[data-dependent-finish-fixed]');
      const target = choice && !choice.hidden ? choice.querySelector('legend') : fixed && !fixed.hidden ? fixed : null;
      selector.querySelectorAll('[data-treatment-help]').forEach(button => { if(button.parentElement !== target)button.remove(); });
      if(!target || target.querySelector('[data-treatment-help]'))return;
      const button=document.createElement('button');
      button.type='button';button.textContent='Gloss vs Matte Lacquer';
      button.dataset.treatmentHelp='';button.setAttribute('aria-haspopup','dialog');
      button.dataset.ihFeature='product-buying-facts';button.dataset.ihAction='treatment_help_open';button.dataset.ihResource='gloss-versus-matte';
      button.addEventListener('click',()=>openHelp(button));target.append(button);
    });
  }
  let queued=false;
  const schedule=()=>{if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;arrange();});};
  function init(){arrange();document.querySelectorAll('product-info').forEach(root=>new MutationObserver(schedule).observe(root,{childList:true,subtree:true,attributes:true,attributeFilter:['hidden']}));}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('product-info:loaded',schedule);
})();
